export const cellRendererAssignStatus = {
    template: `<span> 
                <p v-if="params.data.assignStatus === 'ACTIVE'"   style="color: lightgreen" >ACTIVE</p>
                <p v-if="params.data.assignStatus === 'END'" style="color: dimgrey" >END</p>
                <p v-if="params.data.assignStatus === 'STOP'" style="color: dimgrey" >STOP</p>
                <p v-if="params.data.assignStatus === 'PAUSE'" style="color: dimgrey" >PAUSE</p>  
                <p v-if="params.data.assignStatus === 'NOT_PAID'" style="color: darkgoldenrod" >NOT PAID</p> 
            </span>`
}

export const cellRendererAttendStatus = {
    template: `<span>
                <p v-if="params.data.attendStatus === 'NOCLASS'" style="color: grey" >No Class</p>
                <p v-if="params.data.attendStatus === 'ATTEND'" style="color: seagreen" >출석(Attend)</p>
                <p v-if="params.data.attendStatus === 'NOSHOW'" style="color: orangered" >학생 NoShow</p>
                <p v-if="params.data.attendStatus === 'POSTPONE'" style="color: orange" >연기 Postpone</p> 
                <p v-if="params.data.attendStatus === 'TEACHER_IMPOSSIBLE'" style="color: darkorange" >선생님 불참 Teacher Issue</p> 
            </span>`
}

export const cellRendererMon = {
    template: `<span> 
                <p v-if="params.data.mon === true " style="color: lightgreen; background-color: darkgreen; text-align: center" >Y</p>
                <p v-if="params.data.mon === false " style="color: grey; text-align: center" >N</p>
            </span>`
}
export const cellRendererTue = {
    template: `<span> 
                <p v-if="params.data.tue === true " style="color: lightgreen; background-color: darkgreen; text-align: center" >Y</p>
                <p v-if="params.data.tue === false " style="color: grey; text-align: center" >N</p>
            </span>`
}
export const cellRendererWed = {
    template: `<span> 
                <p v-if="params.data.wed === true " style="color: lightgreen; background-color: darkgreen; text-align: center" >Y</p>
                <p v-if="params.data.wed === false " style="color: grey; text-align: center" >N</p>
            </span>`
}
export const cellRendererThu = {
    template: `<span> 
                <p v-if="params.data.thu === true " style="color: lightgreen; background-color: darkgreen; text-align: center" >Y</p>
                <p v-if="params.data.thu === false " style="color: grey; text-align: center" >N</p>
            </span>`
}
export const cellRendererFri = {
    template: `<span> 
                <p v-if="params.data.fri === true " style="color: lightgreen; background-color: darkgreen; text-align: center" >Y</p>
                <p v-if="params.data.fri === false " style="color: grey; text-align: center" >N</p>
            </span>`
}
export const cellRendererSat = {
    template: `<span>  
                <p v-if="params.data.sat === true " style="color: lightgreen; background-color: darkgreen; text-align: center" >Y</p>
                <p v-if="params.data.sat === false " style="color: grey; text-align: center" >N</p>
            </span>`
}
export const cellRendererSun = {
    template: `<span> 
                <p v-if="params.data.sun === true " style="color: lightgreen; background-color: darkgreen; text-align: center" >Y</p>
                <p v-if="params.data.sun === false " style="color: grey; text-align: center" >N</p>
            </span>`
}
